module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Bnt8uM/tc-custom/9781847674470.jpg?1702840377516",
      "alt": "This image is the cover for the book My First Summer in the Sierra, Canons"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("My First Summer in the Sierra, Canons\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In the summer of 1869, John Muir set out from California's Central Valley with a flock of sheep and trekked into the foothills of the Sierra Nevada. His journals describe the summer he spent in what would become Yosemite National Park. Celebrating the Sierra's lizards and mountain lions, tall trees and waterfalls, fierce thunderstorms and bears, Muir raises an awareness of nature to a spiritual dimension.John Muir is internationally acknowledged as one of the founding fathers of modern conservation and his vision, passion and integrity continue to inspire readers today - particularly in this, his best-loved book.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Muir, Robert Macfarlane\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canongate\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0